module.exports = __webpack_public_path__ + "static/media/logo-white.186e7b8b.png";